import React from 'react';

const ArticleWrapper = ({children}) => {
    return (
        <main className="main-wrapper">
            <article itemScope itemType="http://schema.org/Article">
                {children}
            </article>
        </main>
    );
};

export default ArticleWrapper;
